import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { SelectorModel } from "../../../model/shared/selector.model";
import { environment } from "../../../../environments/environment";
import { apiLink } from "../../../constant/api-link";
import { MyBuilkFeedListQueryModel } from "../../../model/builk/mybuilk/mybuilk-feed.model";
import { LocalStorageService } from "angular-2-local-storage";

@Injectable({
  providedIn: "root"
})
export class MybuilkService {
  messageSize = 200;
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) { }

  sub: any;

  getCompanyCountries(): Observable<Array<string>> {
    const url = `${environment.apiBuilkURL}api/V2/BackOffice/GetCountry`;
    this.sub = this.http.get<Array<string>>(url);
    return this.sub;
  }

  getMyBuilkFeeds(query: MyBuilkFeedListQueryModel): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V2/BackOffice/GetMyBuilkFeeds`;
    let params = new HttpParams()
    .set('CountryCode', query.countryCode)
    .set('PageNumber', query.pageNumber.toString())
    .set('PageSize', query.pageSize.toString())
    .set('TextSearch', query.textSearch)
    .set('Culture', query.culture);

    if (query.date != undefined && query.date != null) {
      params = params.append('Date', query.date.toISOString())
    }
    this.sub = this.http.get<any>(url, { params: params });
    return this.sub;
  }

  comment(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/CreateCommentFeedMyBuilk`;
    this.sub = this.http.post<any>(url, data);

    return this.sub;
  }

  deleteComment(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/DeleteCommentMyBuilkFeed`;
    const params = new HttpParams()
      .set("Id", data.id)
      .set("CommentId", data.timestamp)
      .set("UserSurrKey", data.userId)
      .set("IsAd", data.isAd);
    this.sub = this.http.delete<any>(url, { params });

    return this.sub;
  }

  editComment(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/EditCommentMyBuilkFeed`;
    this.sub = this.http.post<any>(url, data);

    return this.sub;
  }

  likePost(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/PostLikeMyBuilkFeed`;
    this.sub = this.http.post<any>(url, data);

    return this.sub;
  }

  likeComment(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/PostLikeCommentMyBuilkFeed`;
    this.sub = this.http.post<any>(url, data);

    return this.sub;
  }

  deletePost(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/DeleteUserFeed`;
    const params = new HttpParams()
      .set("Id", data.id)
      .set("UserSurrKey", data.userSurrKey);
    this.sub = this.http.delete<any>(url, { params });

    return this.sub;
  }

  getUserFeed(data: any): Observable<any> {
    const url = `${environment.apiBuilkURL}api/V1/MyBuilk/GetFeedMyBuilk`;
    const params = new HttpParams()
      .set("CountryCode", data.countryCode)
      .set("Offset", data.offset.toString())
      .set("Limit", data.limit.toString());
    this.sub = this.http.get<any>(url, { params });

    return this.sub;
  }
  setReadMoreMessage(obj: any): string {
    let messageResult: string = obj.message;
    if (obj.message.length > this.messageSize) {
      obj.readMore = true;
      messageResult = `${obj.message.substring(0, this.messageSize)}...`;
    }

    return messageResult;
  }
  readMore(obj: any): any {
    obj.messageShow = (obj.expand) ? this.setReadMoreMessage(obj) : obj.message;
    obj.expand = !obj.expand;

    return obj;
  }
  initialPost(post: any): any {
    if (post !== undefined) {
      if (post.likes) {
        post.isUserLike = (post.likes.find(like => like.userId === this.currUser().userSurrKey
          || like.userSurrKey === this.currUser().userSurrKey)) ? true : false;
      }
      if (post.message) {
        post.messageShow = this.setReadMoreMessage(post);
        post.expand = false;
      }
      if (post.comments) {
        post.comments.forEach(element => {
          element.messageShow = this.setReadMoreMessage(element);
          element.expand = false;
          if (element.likes) {
            element.isUserLikeComment = (element.likes.find(like => like.userId === this.currUser().userSurrKey
              || like.userSurrKey === this.currUser().userSurrKey)) ? true : false;
          }
        });
      }
    }

    return post;
  }

  currUser(): any {
    return {
      userSurrKey: this.localStorageService.get("userSurrKey"),
      userCulture: this.localStorageService.get("userCulture"),
      userFullName: this.localStorageService.get("userFullName"),
      employeeSurrKey: this.localStorageService.get("employeeSurrKey"),
      companySurrKey: this.localStorageService.get("companySurrKey"),
      userAvatarPath: this.localStorageService.get("userAvatarPath")
    };
  }

  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  addAnchorsToText(text) {
    if (text != undefined && text != null && text != '') {
      let checkText = text.trim();
      if (checkText == '') {
        return '';
      }
    } else {
      return '';
    }
    // https://www.regextester.com/94502
    const regexp =
      /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/gim;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
      // This map helps us to keep a count of the duplicate matches.
      if (map[match] !== undefined) map[match]++;
      else map[match] = 0;

      // These next few lines handle duplicates. We want to handle cases like this:
      // <a href="myurl.com">foo</a> bar baz myurl.com.
      let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
      let newPos = pos - map[match] * (match.length - 1);
      testString = this.insertIntoString(testString, newPos, match);

      // Detect if the url was found here -> <a href="#here#">
      const hrefRegex = new RegExp(
        `<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`,
        'ig'
      );
      const isHref = hrefRegex.test(testString);

      // Detect if the url was found here -> <a href="...">#here#</a>
      const anchoredRegex = new RegExp(
        `<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`,
        'ig'
      );
      const isAnchored = anchoredRegex.test(testString);

      // console.log({match, isAnchored, isHref});
      // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
      if (isAnchored || isHref) return match;
      const hasProtocol = /^http[s]?:\/\/.*$/gim.test(match);
      return `<a href="${
        hasProtocol ? '' : 'http://'
      }${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    });
    function escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }

  dateParse(text: string) {
    const regex = /\/Date\((-?\d+)([+-]\d{4})?\)\//; // Regex pattern to extract the timestamp and timezone offset

    const match = text.match(regex);

    if (match) {
      const timestamp = parseInt(match[1], 10); // Extract the timestamp from the match
      const date = new Date(timestamp); // Create a Date object from the timestamp

      // date.setHours(date.getHours() + 7);

      const day = date.getDate().toString().padStart(2, "0"); // Get the day and pad with leading zero if necessary
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get the month (months are zero-based) and pad with leading zero if necessary
      const year = date.getFullYear().toString(); // Get the full year

      return `${day}/${month}/${year}`;
    }
    return null;
  }
}
